import React from 'react';
import { Route } from 'react-router-dom';
import { RmDashboard } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/rm-dashboard';
import { RmDashBoard, RmProcurementDashboard } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/rm-procurement-dashboard';
import { IndentGrid } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/indent-grid';
import { IndentForm } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/indent-form';
import { VehicleAssignmentGrid } from '@gtpl/pages/transportation/transportation-components/vehicle-assignment-grid';
import { IndentDetailView } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/indent-detail-view';
import { VehicleAssignmentForm } from '@gtpl/pages/transportation/transportation-components/vehicle-assignment-form';
import { VehicleMasterForm } from '@gtpl/pages/master/master-components/vehicle-master-form';
import { IndentFromForPreparedMaterial } from '@gtpl/pages/procurement/packing-materials-components/indent-from-for-prepared-material';
import { RawMaterialGrnForm } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/raw-material-grn-form';
import { RawMaterialGrnDetailView } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/raw-material-grn-detail-view';
import { RmVehicleInspection } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/rm-vehicle-inspection';
import { VehicleMasterGrid } from '@gtpl/pages/master/master-components/vehicle-master-grid';
import { RmIndentQtyLimit } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/rm-indent-qty-limit';
import { RmIndentQtyLimitGrid } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/rm-indent-qty-limit-grid';
import { RawMaterialGrnGrid } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/raw-material-grn-grid';
import { BomTrackerGrid } from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/bom-tracker-grid';
import {RmInvoiceForm} from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/rm-invoice'
import {Reweighment, ReweighmentForm} from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/reweighment'
import {RMInvoiceView} from '@gtpl/pages/raw-material-procurement/raw-material-procurement-components/rm-invoice'
import reweighmentGrid from 'libs/pages/raw-material-procurement/raw-material-procurement-components/reweighment/src/lib/reweighment-grid';

export const RmProcurementRoute = () => {
  return (
    <>
      <Route exact path="/procurement-dashboard" component={RmProcurementDashboard}/>
      {/* <Route exact path="/rm-dashboard" component={RmDashboard} /> */}
      <Route exact path="/rm-dashboard" component={RmDashBoard} />

      <Route exact path="/rm-grn-form/:id?" component={RawMaterialGrnForm} />
      <Route exact path="/rm-grn-detailview" component={RawMaterialGrnDetailView}/>
      <Route exact path="/rm-grn-grid" component={RawMaterialGrnGrid} />
      <Route exact path="/rm-invoice-form" component={RmInvoiceForm} />
      <Route exact path="/rm-grn-vehicle-inspection" component={RmVehicleInspection}/>
      <Route exact path="/rm-indent-qty-limit-grid" component={RmIndentQtyLimitGrid}/>
      <Route exact path="/reweighment-form" component={ReweighmentForm} />
      <Route exact path="/rm-price-acceptance-form" component={RMInvoiceView} />
      <Route exact path="/rm-indent-qty-limit"
        render={(props) => (
          <RmIndentQtyLimit
            rmIndentQtyLimitData={undefined}
            isUpdate={false}
            closeForm={() => {}}
            updateRmIndentQtyLimit={() => {}}
          />
        )}
      />

      <Route exact path="/indent-view" component={IndentGrid} />
      <Route exact path="/reweighment-view" component={reweighmentGrid} />

      <Route exact path="/indent-form"
        render={(props) => (
          <IndentForm
            indentData={undefined}
            isUpdate={false}
            // form={''}
            closeDrawer={() => {}}
            // updateIndent={(undefined => { })}
          />
        )}
      />
      <Route exact path="/indent-detail-view" component={IndentDetailView} />
      <Route exact path="/vehicle-assignment" component={VehicleAssignmentGrid}/>
      <Route exact path="/assign-vehicle" component={VehicleAssignmentForm} />
      <Route exact path="/vehicle-grid" component={VehicleMasterGrid} />
      <Route exact path="/vehicle-form" render={(props) => (
          <VehicleMasterForm
            vehiclesData={undefined}
            isUpdate={false}
            closeForm={() => {}}
            updateVehicle={(undefined) => {}}
          />
        )}
      />

      <Route exact path="/bom-tracker-grid" component={BomTrackerGrid} />
    </>
  );
};
